import { storage } from '../firebaseConfig'; // Firestore setup
import { ref, getDownloadURL } from 'firebase/storage'; // Firestore functions


export const getSound = async(sound, type) => {
    try {
        // Reference to the audio file in the Cloud Storage bucket
        const audioRef = ref(storage, `${type}/${sound}`);
        // Get the download URL
        const url = await getDownloadURL(audioRef);
        return url;
    } catch (error) {
        console.error('Error fetching audio URL:', error);
    }
}